import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iCalculationProcessStepListingState, iCalculationProcessStepListingResponse } from 'store/types/assembler';

export const initialState: iCalculationProcessStepListingState = {
  calculationProcessStepListing: null,
};

export const calculationProcessStepListingSlice = createSlice({
  name: 'calculationProcessStepListing',
  initialState,
  reducers: {
    setCalculationProcessStepListing: (state, action: PayloadAction<iCalculationProcessStepListingResponse>) => {
        const calculationProcessStepListing: iCalculationProcessStepListingResponse = action.payload
        state.calculationProcessStepListing = calculationProcessStepListing
    }
  }
});

// The exported reducer
export default calculationProcessStepListingSlice.reducer;
// Export the action
export const { setCalculationProcessStepListing } = calculationProcessStepListingSlice.actions;
// Optional selector
export const calculationProcessStepListingReducerState = (state: RootState) => state.calculationProcessStepListing;
